import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutations'
import * as actions from './actions'

Vue.use(Vuex)
//'ex_equipment_category', 'ex_equipment_data', 'ex_equipment_enhance_data'
const state = {
	globalLoading:{
		isLoading: false
	},
    equipmentCraft:{},
    equipmentData:{},
    equipmentEnhanceRate:{},
    questData:{},
    questRewardData:{},
    waveGroupData:{},
    enemyRewardData:{},
    unitData:{},
    actualUnitBackground:{},
    questAreaData:{},
    unitProfile:{},
    unitPromotion:{},
    unitSkillData:{},
    unitAttackPattern:{},
    skillData:{},
	charaIdentity:{},
	enemyParameter:{},
	skillAction:{},
	uniqueEquipmentData: {},
	uniqueEquipmentEnhanceData: {},
	uniqueEquipmentEnhanceRate: {},
	unitPromotionStatus: {},
	unitRarity: {},
	userStatus: {},	
	exEquipmentCategory: {},
	exEquipmentData: {},
	exEquipmentEnhance_data: {},
    talentQuestData: {},
    talentQuestAreaData: {},
    unitTalent: {}
}

const getters = {
	getGlobalLoading(state) {
        return state.globalLoading;
    },
    getEquipmentCraft(state) {
        return state.equipmentCraft;
    },
    getEquipmentData(state) {
        return state.equipmentData;
    },    
    getEquipmentEnhanceRate(state) {
        return state.equipmentEnhanceRate;
    },
    getQuestData(state) {
        return state.questData;
    },
    getQuestRewardData(state) {
        return state.questRewardData;
    },
    getWaveGroupData(state) {
        return state.waveGroupData;
    },
    getEnemyRewardData(state) {
        return state.enemyRewardData;
    },
    getUnitData(state) {
        return state.unitData;
    },
    getActualUnitBackground(state) {
        return state.actualUnitBackground;
    },
    getQuestAreaData(state) {
        return state.questAreaData;
    },
    getUnitProfile(state) {
        return state.unitProfile;
    },
    getUnitPromotion(state) {
        return state.unitPromotion;
    },
    getUnitSkillData(state) {
        return state.unitSkillData;
    },
    getUnitAttackPattern(state) {
        return state.unitAttackPattern;
    },
    getSkillData(state) {
        return state.skillData;
    },
	getCharaIdentity(state) {
		return state.charaIdentity;
	},
	getEnemyParameter(state) {
		return state.enemyParameter;
	},
	getSkillAction(state) {
		return state.skillAction;
	},
	getUniqueEquipmentData(state) {
		return state.uniqueEquipmentData;
	},
	getUniqueEquipmentEnhanceData(state) {
		return state.uniqueEquipmentEnhanceData;
	},
	getUniqueEquipmentEnhanceRate(state) {
		return state.uniqueEquipmentEnhanceRate;
	},
	getUnitPromotionStatus(state) {
		return state.unitPromotionStatus;
	},
	getUnitRarity(state) {
		return state.unitRarity;
	},
	getUserStatus(state) {
		return state.userStatus;
	},
	getExEquipmentCategory(state) {
		return state.exEquipmentCategory;
	},
	getExEquipmentData(state) {
		return state.exEquipmentData;
	},
	getExEquipmentEnhanceData(state) {
		return state.exEquipmentEnhanceData;
	},
	getTalentQuestData(state) {
		return state.talentQuestData;
	},
    getTalentQuestAreaData(state) {
		return state.talentQuestAreaData;
	},
    getUnitTalent(state) {
		return state.unitTalent;
	}

}

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions
})
